import React from 'react';
import styled from 'styled-components';

import { PBB_INCENTIVES_TERMS_URL } from 'src/payments/constants';
import { BankOutlineIcon } from 'src/assets/bank-outline-icon';
import { CoinDepositIcon } from 'src/assets/coin-deposit-icon';
import { PhoneBankIcon } from 'src/assets/phone-bank-icon';
import { Typography } from 'src/typography';

export const bankStatementTerms = (value: number): string =>
  `Your bank statement will show your order charge and a separate $${value} deposit. ` +
  `Valid only on first Pay by Bank order. Eligibility requirements apply.`;

type CashBackDetailsProps = {
  paymentStepText?: string;
  value: number;
};

export const CashBackDetails = ({
  paymentStepText = 'Pay at checkout with your bank',
  value,
}: CashBackDetailsProps): JSX.Element => (
  <div>
    <StepsList>
      <Step>
        <BankOutlineIcon />
        <StepContent>1. Link your bank</StepContent>
      </Step>
      <Step>
        <PhoneBankIcon />
        <StepContent>2. {paymentStepText}</StepContent>
      </Step>
      <Step>
        <CoinDepositIcon />
        <StepContent>3. Get ${value} back in your bank.</StepContent>
      </Step>
    </StepsList>
    <Typography.Label size='small'>
      {bankStatementTerms(value)}
      <br />
      <CashBackTermsLink>View full terms</CashBackTermsLink>
    </Typography.Label>
  </div>
);

export const CashBackTermsLink = styled.a.attrs({
  href: PBB_INCENTIVES_TERMS_URL,
  target: '_blank',
  rel: 'noreferrer',
})``;

const StepsList = styled.ul`
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  gap: 8px;
  list-style: none;
  margin: 0 0 ${({ theme }) => theme.spaces[4]};
  padding: 0;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-template-rows: auto;
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Step = styled.li`
  align-items: center;
  color: var(--dcm-pbb-incentive-step-icon-color, ${({ theme }) => theme.colors.green90});
  display: flex;
  flex-direction: row;
  gap: 8px;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const StepContent = styled(Typography.Label).attrs({ size: 'small' })`
  color: var(--dcm-pbb-incentive-step-text-color, ${({ theme }) => theme.colors.black});
`;
